import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// Blocks back navigation on Android (hardware back button) and iOS (swipe-back gesture).
// iOS Safari starts a native slide animation before JS can intercept it, so two extra
// layers are needed: overflow-x:hidden removes the horizontal boundary the gesture uses,
// and a non-passive touchstart listener cancels touches within 16px of the left edge.
const useBlockBackNavigation = () => {
  const history = useHistory();

  useEffect(() => {
    const unblock = history.block((_, action) => (action === 'POP' ? false : undefined));
    const prevOverflowX = document.body.style.overflowX;
    document.body.style.overflowX = 'hidden';

    const preventEdgeSwipe = (e: TouchEvent) => {
      if (e.touches[0].clientX < 16) { e.preventDefault(); }
    };
    document.addEventListener('touchstart', preventEdgeSwipe, { passive: false });

    return () => {
      unblock();
      document.body.style.overflowX = prevOverflowX;
      document.removeEventListener('touchstart', preventEdgeSwipe);
    };
  }, [history]);
};

export default useBlockBackNavigation;
